<template>
    <div class="bg-white">
        <div class="md:flex md:flex-wrap">
            <div class="flex-1 p-8" :class="`bg-${model.color}-100`">
                <div class="main-body article" v-html="model.text" />
            </div>
            <div class="flex-1">
                <img :src="model.image" />
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: ['model'],
    methods: {
        log(obj) {
            console.log(obj);
        }
    }
};
</script>
